import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Dropdown, Menu } from 'antd';
import './ContextMenu.less';
const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        icon: PropTypes.element,
        color: PropTypes.string,
      }),
      label: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  cssClass: PropTypes.string,
};
const defaultProps = {
  items: [],
  cssClass: '',
};

export default class ContextMenu extends Component {
  checkPermission = (isAccessAllowed, element) => {
    if (isAccessAllowed) {
      return element;
    } else {
      return null;
    }
  };

  render() {
    const { items, permissions, children, rootContainer, cssClass } = this.props;

    const childrenElements = items.map((item, i) => {
      const contextMenuItem = {
        key: i,
        onClick: item.onClick || (() => {}),
        icon: item.icon.icon,
        label: <span>{item.label}</span>,
      };

      switch (item.id) {
        case 'previewFile':
        case 'download':
          return permissions ? this.checkPermission(permissions.filePermissions.canView, contextMenuItem) : null;
        case 'upload':
        case 'uploadFolder':
        case 'createFolder':
        case 'copyTo':
          return permissions ? this.checkPermission(permissions.filePermissions.canAdd, contextMenuItem) : null;
        case 'rename':
        case 'descriptionEdit':
        case 'moveTo':
        case 'send':
        case 'markAsInsuredVisible':
        case 'unmarkAsInsuredVisible':
        case 'createNote':
        case 'createTask':
        case 'createServiceRequest':
          return permissions ? this.checkPermission(permissions.filePermissions.canEdit, contextMenuItem) : null;
        case 'delete':
          return permissions ? this.checkPermission(permissions.filePermissions.canDelete, contextMenuItem) : null;
        default:
          return contextMenuItem;
      }
    });

    return (
      <Dropdown className={cssClass} menu={{ items: childrenElements }} trigger={['contextMenu']} getPopupContainer={rootContainer}>
        {children}
      </Dropdown>
    );
  }
}

ContextMenu.propTypes = propTypes;
ContextMenu.defaultProps = defaultProps;
